import { FILM_THUMBNAIL_URL } from '../config/media';

export const filmProducts = [
{
  id: 1,
  name: 'ES255',
  mil: 2.8,
  micron: 71,
  pp: true,
  apetPet: true,
  cpet: true,
  pe: true,
  paper: true,
  peelable: true,
  weld: 'PE-Weld',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/ES-255-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 2,
  name: 'ES-255-F2',
  mil: 3.05,
  micron: 77,
  pp: true,
  apetPet: true,
  cpet: true,
  pe: true,
  paper: true,
  peelable: true,
  weld: 'PE-Weld',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/ES-255-F2-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 3,
  name: 'LTX-244',
  mil: 2.45,
  micron: 62,
  pp: true,
  apetPet: true,
  cpet: true,
  pe: true,
  paper: true,
  peelable: true,
  weld: 'PE-Weld',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/LTX-244-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 4,
  name: 'GT-44AF100',
  mil: 1.0,
  micron: 25,
  pp: false,
  apetPet: true,
  cpet: false,
  pe: false,
  paper: false,
  peelable: false,
  weld: '',
  highBarrier: true,
  antifogging: true,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: true,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/GT-44AF-100-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 5,
  name: 'GT-PET-L-120',
  mil: 1.2,
  micron: 30,
  pp: false,
  apetPet: true,
  cpet: false,
  pe: false,
  paper: false,
  peelable: false,
  weld: 'YES',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: false,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/GT-PET-L-120-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 6,
  name: 'TP5-118',
  mil: 1.18,
  micron: 30,
  pp: false,
  apetPet: true,
  cpet: true,
  pe: false,
  paper: true,
  peelable: true,
  weld: '',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: false,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/Teinnovations-LLC-TP5-118.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 7,
  name: 'TP7-164',
  mil: 1.64,
  micron: 42,
  pp: true,
  apetPet: false,
  cpet: false,
  pe: false,
  paper: false,
  peelable: true,
  weld: '',
  highBarrier: true,
  antifogging: true,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: false,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/Teinnovations-LLC-TP7-164.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 8,
  name: 'TPP-168',
  mil: 1.68,
  micron: 43,
  pp: true,
  apetPet: false,
  cpet: false,
  pe: false,
  paper: false,
  peelable: false,
  weld: 'YES',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: false,
  ovenable: false,
  specSheet: "https://teinnovations.com/wp-content/uploads/2025/05/Teinnovations-LLC-TPP-168.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 9,
  name: 'TP5-164',
  mil: 1.64,
  micron: 42,
  pp: true,
  apetPet: true,
  cpet: true,
  pe: true,
  paper: true,
  peelable: true,
  weld: 'PE-Weld',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: true,
  specSheet: "http://teinnovations.com/wp-content/uploads/2025/09/Teinnovations-LLC-TP5-164.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
{
  id: 10,
  name: 'LTX-263',
  mil: 2.63,
  micron: 67,
  pp: true,
  apetPet: true,
  cpet: true,
  pe: true,
  paper: true,
  peelable: true,
  weld: 'PE-Weld',
  highBarrier: true,
  antifogging: false,
  perforation: true,
  printable: true,
  microwavable: true,
  freezable: true,
  ovenable: false,
  specSheet: "http://teinnovations.com/wp-content/uploads/2025/09/LTX-263-Spec-Sheet.pdf",
  imageUrl: FILM_THUMBNAIL_URL,
},
];
